import raw from "./mirror-tool.svg?raw";
import { stripIconSvg } from "./stripIconSvg";

/** Mirror sub-tool icon (issue #180) — see `src/icons/mirror-tool.svg` for the
 *  glyph and for why its paint lives in `style`.
 *
 *  The artwork is a FILE now (#216), so the static sub-toolbar buttons inline it
 *  straight into `index.html` through the `<!-- svg:… -->` marker. This constant
 *  serves the places that are genuinely dynamic — the construction sub-toolbar's
 *  per-mode icon map, which composes a magic-wand badge onto it, and the
 *  layers-panel "mirror" chip. Both go through the same {@link stripIconSvg} the
 *  build-time inliner uses, so the static and dynamic copies of one glyph can't
 *  drift apart. */
export const MIRROR_TOOL_ICON_SVG = stripIconSvg(raw);
